// api.js
const headers = {
  Authorization: "Bearer local@7KpRq3XvF9",
  "Content-Type": "application/json", // You can add other headers if needed
};

export default headers;
